import { faWallet } from '@fortawesome/pro-solid-svg-icons';
import type { PropsWithChildren } from 'react';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useWalletDrawerContext } from '@sorare/core/src/contexts/walletDrawer';

export const WalletButton = ({ children }: PropsWithChildren) => {
  const { toggleDrawer } = useWalletDrawerContext();

  return (
    <ButtonBase onClick={toggleDrawer}>
      <Horizontal>
        <IconButton size="medium" color="transparent" icon={faWallet} asSpan />
        {children}
      </Horizontal>
    </ButtonBase>
  );
};
